import { createApp } from 'vue'
import HoursDifference from './HoursDifference.vue'
import './assets/global.css'

createApp(HoursDifference).mount('#hours')
